import React, { useEffect, useState } from 'react';
import ChartRanking from './ChartRanking';
import MediaChart from './MediaChart';

export default function AdminView(props) {

    const {
        percentageHeight,
        chartData,
        media
    } = props?.data

    return (
        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, width: '100%', height: '100%', paddingTop: 30 }}>
            {chartData?.length > 0 &&
                <>
                    <MediaChart media={[{ name: 'Média da Equipe', value: parseFloat(media.toFixed(2)) }]} chartHeight={120} barHeight={120} />
                    <ChartRanking percentageHeight={percentageHeight} data={chartData} media={media} />
                </>
            }
        </div>
    );
}